/// <amd-module name="Wit/Settings/BoardsExternalIntegration/components/panels/BasePanelContent.Props" />
export interface IBasePanelContentProps {
    /**
     * Callback to dismiss the panel
     */
    onDismiss: () => void;
}
